// Paleta para los colores de nivel.
//
// Los bloques del calendario se pintan con el color del nivel y el texto va en
// BLANCO, así que todos los tonos son lo bastante oscuros para mantener el
// contraste legible (≈4.5:1 sobre blanco). Además son distinguibles entre sí,
// que es el objetivo real: poder leer la semana de un vistazo.
//
// Antes TODOS los niveles se creaban con el mismo verde (#40a136) por defecto,
// así que el calendario salía monocromo y el color no aportaba información.
export const NIVEL_COLOR_PALETTE = [
    '#2563eb', // azul
    '#c026d3', // fucsia
    '#047857', // verde
    '#b45309', // ámbar
    '#e11d48', // rosa
    '#0e7490', // cian
    '#7c3aed', // violeta
    '#c2410c', // naranja
    '#4d7c0f', // lima
    '#475569', // pizarra
];

/**
 * Devuelve el primer color de la paleta que todavía no use ningún nivel, para
 * que dos niveles nuevos nunca nazcan con el mismo color. Si ya se agotó la
 * paleta, rota (los repetidos son inevitables a partir de ahí).
 */
export const pickNextLevelColor = (usedColors: (string | undefined)[] = []): string => {
    const used = new Set(
        usedColors.filter(Boolean).map((c) => (c as string).toLowerCase()),
    );
    const free = NIVEL_COLOR_PALETTE.find((c) => !used.has(c.toLowerCase()));
    return free ?? NIVEL_COLOR_PALETTE[used.size % NIVEL_COLOR_PALETTE.length];
};
